import { createContext } from 'react'

const CoordsContext = createContext([])

export default CoordsContext
